module.exports = __webpack_public_path__ + "static/pic06-b8f24861d08ec63c6f034c2cf534742e.png";